//
// Module for Tax ID Edit view
//
rs.module("fund/configuration/taxids/edit",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {
            var taxIDForm = $.js(jsSelectors.taxIDForm);
            var taxIDTypeSelect = taxIDForm.js(jsSelectors.taxIDTypeSelect);
            var taxID = taxIDForm.js(jsSelectors.taxID);

            taxIDTypeSelect.on("change", toggleTaxIDValidation);
            toggleTaxIDValidation();

            // Turn off validation for state tax IDs to allow 8 digit FEINs
            function toggleTaxIDValidation() {
                if (taxIDTypeSelect.val() == codeValues.state) {
                    taxID.attr("data-val", false);
                }
                else {
                    taxID.attr("data-val", true);
                }
                $.validator.resetValidation(taxIDForm);
                taxID.clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);